import React, { useEffect, useState } from "react";
import { Drawer } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setClipArtDrawer } from "../../slices/creatorSlice";
import { FaSearch } from "react-icons/fa";
// import axios from "axios";

import fabric from "../../fabric";
const ClipArtDrawer = ({ canvas }) => {
  const visible = useSelector((state) => state.creator.clipArtDrawerOpen);
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const [searchList, setSearchList] = useState([]);

  function importAll(r) {
    return r.keys().map(r);
  }

  const loadSvg = async (path) => {
    // const res = await axios.get(
    //   "https://reserve.freesvg.org/api/v1/search?query=search",
    //   {
    //     headers: {
    //       Accept: "application/json",
    //       Authorization:
    //         process.env.REACT_FREESVG_TOKEN,
    //     },
    //   }
    // );
    // console.log(res);
    fabric.loadSVGFromURL(path, function(objects, options) {
      var obj = fabric.util.groupSVGElements(objects, options);
      const scale = Math.min(
        canvas.height / obj.height,
        canvas.width / obj.width
      );
      obj.set({
        scaleX: (scale * 25) / 100,
        scaleY: (scale * 25) / 100,
      });
      canvas.centerObject(obj);
      canvas.add(obj).renderAll();
    });
  };
  useEffect(() => {
    const images = importAll(
      require.context("../../CommonFunctions/svgFile", false, /\.(svg)$/)
    );
    setList(images.sort());
    setSearchList(images.sort());
  }, []);

  const handleChange = (e) => {
    if (e.target.value) {
      setSearchList([]);
      list.map((items) => {
        const tags = items.split("-");
        const search =
          tags.includes(e.target.value) ||
          tags.includes("/static/media/" + e.target.value);
        if (search) {
          setSearchList((data) => [...data, items]);
        }
        return null;
      });
    } else {
      setSearchList(list);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <Drawer
      title="ClipArts"
      placement={"left"}
      closable={true}
      onClose={() => {
        dispatch(setClipArtDrawer(!visible));
      }}
      visible={visible}
      key={"left"}
    >
      <div className="flex justify-between items-center w-full mb-6">
        <input
          type="text"
          onChange={handleChange}
          className="w-full h-auto border-blue-200 border rounded-md mr-2 py-1 text-[18px] focus:border-blue-400 focus:outline-blue-300 font-medium pl-1"
        />
        <button
          onClick={handleSubmit}
          className="w-max max-w-max bg-blue-200 text-black font-bold rounded-full p-3 ml-2"
        >
          <FaSearch />
        </button>
      </div>
      {searchList.length > 0 ? (
        <div className="grid grid-cols-3 w-auto gap-0">
          {searchList.map((path) => {
            return (
              <div
                className="p-3 m-2 bg-cover h-[100px] w-[100px] flex items-center justify-center"
                key={path}
              >
                <img
                  src={path}
                  alt={path}
                  onClick={(e) => {
                    e.preventDefault();
                    loadSvg(path);
                  }}
                />
              </div>
            );
          })}
        </div>
      ) : (
        "Sorry, Icon not found."
      )}
    </Drawer>
  );
};

export default ClipArtDrawer;
